// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#toolbar-wrapper {
    width: 100%;
    height: 60px;
    background: lightgray;
    z-index: 20;
    box-shadow: 0 10px 10px darkgray;
    position: fixed;
}

#toolbar-content {
    /* max-width: 1920px; */
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}

#toolbar-navigation{
    display: flex;
    align-items: center;
    height: 60px;
}

.toolbarButton{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 160px;
    height: 40px;
    background: var(--psblue);
    font-family: Font-Semibold;
    color: white;
    text-decoration: none;
    font-size: 1rem;
    margin: 0 5px;
    border: none;
    border-radius: 5px;
    transition: all 0.1s ease 0s;
}
.toolbarButton>*{
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Font-Semibold;
    color: white;
    cursor: pointer;
}
.toolbarButton:hover {
    background: var(--psyellow)
}

#autosaveIndicator {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 200px;
    background: var(--psblue);
    font-family: Font-Semibold;
    color: white;
    text-decoration: none;
    font-size: 1rem;
    margin: 2px 10px;
    border: none;
    border-radius: 5px;
    transition: all 0.2s ease 0s;
    opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/toolbar/toolbar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,WAAW;IACX,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;IAC1B,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;AACnB;AACA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;IAC1B,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,UAAU;AACd","sourcesContent":["#toolbar-wrapper {\n    width: 100%;\n    height: 60px;\n    background: lightgray;\n    z-index: 20;\n    box-shadow: 0 10px 10px darkgray;\n    position: fixed;\n}\n\n#toolbar-content {\n    /* max-width: 1920px; */\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n}\n\n#toolbar-navigation{\n    display: flex;\n    align-items: center;\n    height: 60px;\n}\n\n.toolbarButton{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    width: 160px;\n    height: 40px;\n    background: var(--psblue);\n    font-family: Font-Semibold;\n    color: white;\n    text-decoration: none;\n    font-size: 1rem;\n    margin: 0 5px;\n    border: none;\n    border-radius: 5px;\n    transition: all 0.1s ease 0s;\n}\n.toolbarButton>*{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: Font-Semibold;\n    color: white;\n    cursor: pointer;\n}\n.toolbarButton:hover {\n    background: var(--psyellow)\n}\n\n#autosaveIndicator {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 200px;\n    background: var(--psblue);\n    font-family: Font-Semibold;\n    color: white;\n    text-decoration: none;\n    font-size: 1rem;\n    margin: 2px 10px;\n    border: none;\n    border-radius: 5px;\n    transition: all 0.2s ease 0s;\n    opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
